import React, { useState } from "react";
import { Button, Checkbox, Input, Modal, Space } from 'antd';
import { useAppSelector, useAppDispatch } from 'common/hooks/redux'
import { RootState } from "store/index";
import { toggleWhiteGlobeWalletModal } from "store/global"
import { Typography } from "antd";
import { MARKETPLACE_URL } from "common/constants";

const { Text } = Typography;

/**
 * @param {ActionType} props
 */

const WhiteGlobeWalletModal: React.FC<any> = (): React.ReactElement => {
  const dispatch = useAppDispatch();
  const whiteGlobeWalletModal = useAppSelector((state: RootState) => state.global.whiteGlobeWalletModal);

  const [keepUpdated, setKeepUpdated] = useState(false);


  function toggleModal(visible: boolean = false) {
    dispatch(toggleWhiteGlobeWalletModal(visible))

    if (!visible) {
      setKeepUpdated(false);
    }
  }

  const handleContinue = async () => {
    window.open(`${MARKETPLACE_URL}/contact-us`, "_blank");
    toggleModal(false);
  };

  const isFormValid = keepUpdated;

  return (
    <Modal
      open={whiteGlobeWalletModal}
      title=""
      width="auto"
      style={{ maxWidth: "600px" }}
      wrapClassName="action-complete"
      onCancel={() => toggleModal(false)}
      closeIcon={true}
      footer={null}
    >
      <div className="inner-wrapper" style={{ padding: "20px 0", textAlign: "center" }}>
      <p style={{ color: "#ccc", lineHeight: "1.6", fontSize: "15px" }}>
        We’re currently in beta, offering a personalised ‘white-glove’ service for creating Rekords. Our self-service platform will be launching soon.
      </p>
      <p style={{ color: "#ccc", marginTop: "12px", fontSize: "15px" }}>
        In the meantime, if you’d like to create a Rekord, please email
        <br />
        <a 
          href="mailto:simon@onrekord.io" 
          style={{ color: "#C1FC49", fontWeight: "bold" }}
        >
          simon@onrekord.io
        </a>
      </p>
    </div>
    </Modal>
  );
  
};

export default WhiteGlobeWalletModal;